import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  DEFAULT_START_DATE_REPORTS,
  ONLY_DATE_SHOW_FORMAT,
} from '../../constants/constants';
import {logoutAction} from '../rootAction';
import {getFormatedDateForFilter} from '../../components/common/aur-data-grid-pro/useServerSideDataGrid';

interface IReceivedDate {
  fromDate: string;
  toDate: string;
}

interface IntakeAuditTabState {
  filtersAndChipDate: IReceivedDate;
  hasFilterValueChanged: boolean;
}

export const initialState: IntakeAuditTabState = {
  filtersAndChipDate: {
    fromDate: getFormatedDateForFilter(
      DEFAULT_START_DATE_REPORTS,
      ONLY_DATE_SHOW_FORMAT
    ),
    toDate: getFormatedDateForFilter(new Date(), ONLY_DATE_SHOW_FORMAT),
  },
  hasFilterValueChanged: false,
};

const intakeAuditTabSlice = createSlice({
  name: 'intakeAuditTab',
  initialState,
  reducers: {
    setFromDate: (state, action: PayloadAction<string>) => {
      state.filtersAndChipDate.fromDate = action.payload;
    },
    setToDate: (state, action: PayloadAction<string>) => {
      state.filtersAndChipDate.toDate = action.payload;
    },
    setHasFilterValueChanged: (state, action: PayloadAction<boolean>) => {
      state.hasFilterValueChanged = action.payload;
    },
    resetToDefault: (state) => {
      state.filtersAndChipDate = {...initialState.filtersAndChipDate};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => {
      return initialState;
    });
  },
});

export const {
  setFromDate,
  setToDate,
  setHasFilterValueChanged,
  resetToDefault,
} = intakeAuditTabSlice.actions;

export default intakeAuditTabSlice.reducer;
